import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from "rxjs";
import { CreateUserRulesTemplateRequest } from "../../domain/requests/user-rules-template";
import { UserRulesTemplateRepository } from "../../repositories/user-rules-template.repository";
@Injectable({ providedIn: 'root' })
export class CreateUserRulesTemplateUsecase implements UseCase<CreateUserRulesTemplateRequest, string> {
  constructor(private readonly userRulesTemplateRepository: UserRulesTemplateRepository) {
  }

  execute(params: CreateUserRulesTemplateRequest): Observable<string> {
    return this.userRulesTemplateRepository.CreateUserRulesTemplate(params);
  }
}
